import { render, staticRenderFns } from "./SupportContainer.vue?vue&type=template&id=800ef4c2&"
import script from "./SupportContainer.vue?vue&type=script&lang=js&"
export * from "./SupportContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports